<template>
    <div class="seller-badge-list">
        <h1 class="wp-heading-inline">
            {{ __( 'Seller Badge', 'dokan') }}
        </h1>
        <router-link :to="{ name: 'NewSellerBadge' }" class="page-title-action pull-right">{{ __( '+ Create Badge', 'dokan' ) }}</router-link>
        <p class="list_description mt-2 mb-2">
            {{ __( 'A platform where sellers are given badge by their activities.', 'dokan' ) }}
        </p>
        <AdminNotice />
        <hr class="wp-header-end">
        <div class="dokan-seller-badge-lists">
            <ul class="subsubsub">
                <li>
                    <router-link
                        :class="{current: getCurrentBadgeStatus === 'all'}"
                        :to="{ name: 'SellerBadgeList', query: { badge_status: 'all' }}"
                        active-class="current" exact >
                        {{ __( 'All', 'dokan' ) }} <span class="count">{{ counts.all }}</span>
                    </router-link> |
                </li>
                <li>
                    <router-link
                        :class="{current: getCurrentBadgeStatus === 'published'}"
                        :to="{ name: 'SellerBadgeList', query: { badge_status: 'published' }}"
                        active-class="current" exact >
                        {{ __( 'Published', 'dokan' ) }} <span class="count">{{ counts.published }}</span>
                    </router-link> |
                </li>
                <li>
                    <router-link
                        :class="{current: getCurrentBadgeStatus === 'draft'}"
                        :to="{ name: 'SellerBadgeList', query: { badge_status: 'draft' }}"
                        active-class="current" exact >
                        {{ __( 'Draft', 'dokan' ) }} <span class="count">{{ counts.draft }}</span>
                    </router-link>
                </li>
            </ul>
            <div class="search-by-order">
                <search @searched="searchByBadge" :title="__( 'Search by badge name', 'dokan' )" />
            </div>
            <div id="seller_badge_list_table">
                <list-table
                    :columns="columns"
                    :loading="loading"
                    :rows="requests"
                    :actions="actions"
                    :action-column="actionColumn"
                    :show-cb="showCb"
                    :bulk-actions="bulkActions"
                    :not-found="notFound"
                    :total-pages="totalPages"
                    :total-items="totalItems"
                    :per-page="perPage"
                    :current-page="getCurrentPage"
                    @pagination="goToPage"
                    :sort-by="getSortBy"
                    :sort-order="getSortOrder"
                    @sort="doSort"
                    @bulk:click="handleBulkAction">

                    <template slot="badge_name" slot-scope="data">
                        <img :src="data.row.badge_logo" :alt="data.row.badge_name">
                        <strong><a :href="editBadgeURL( data.row.id )">{{ data.row.badge_name }}</a></strong>
                    </template>

                    <template slot="event_type" slot-scope="data">
                        <span>{{ data.row.event.title }}</span>
                        <span class="level_count" v-html="sprintf( 'Level: %s%d%s', '<strong>', data.row.level_count, '</strong>' )"></span>
                    </template>

                    <template slot="vendor_count" slot-scope="data">
                        <span class="dashicons dashicons-admin-users"></span> <router-link :to="{ name: 'Vendors', query: { badge_id: data.row.id} }" exact ><span class="count">{{ data.row.vendor_count }}</span></router-link>
                    </template>

                    <template slot="badge_status" slot-scope="data" class="badge_status">
                        <span class='draft' :class="{published: data.row.badge_status === 'published'}">
                            {{data.row.formatted_badge_status}}
                        </span>
                    </template>

                    <template slot="row-actions" slot-scope="data">
                        <template v-for="(action, index) in actions">
                            <span :class="action.key" v-if="action.key === 'edit'">
                                <a :href="editBadgeURL( data.row.id )">{{ action.label }}</a> |
                            </span>
                            <span :class="action.key" v-if="action.key === 'view'">
                                <a href="#" @click.prevent="viewBadgeDetails(data.row.id)">{{ action.label }}</a> |
                            </span>
                            <span :class="action.key" v-if="action.key === 'show_vendors'">
                                <router-link :to="{ name: 'Vendors', query: { badge_id: data.row.id} }" exact >{{ action.label }}</router-link> |
                            </span>
                            <span :class="action.key" v-if="action.key === 'publish' && data.row.badge_status === 'draft'">
                                <a href="#" @click.prevent="handleRowAction( 'publish', data.row.id)">{{ action.label }}</a> |
                            </span>
                            <span :class="action.key" v-if="action.key === 'draft' && data.row.badge_status === 'published'">
                                <a href="#" @click.prevent="handleRowAction( 'draft', data.row.id )">{{ action.label }}</a> |
                            </span>
                            <span :class="action.key" v-if="action.key === 'delete'">
                                <a href="#" @click.prevent="handleRowAction( 'delete', data.row.id)">{{ action.label }}</a>
                            </span>
                        </template>
                    </template>
                </list-table>
            </div>

            <BadgeDetails v-if="badge.id" />
        </div>
    </div>
</template>

<script>
const ListTable   = dokan_get_lib('ListTable')
const Debounce    = dokan_get_lib('debounce')
const Search      = dokan_get_lib('Search')
const AdminNotice = dokan_get_lib('AdminNotice')

import Modal        from '../../components/Modal.vue';
import BadgeDetails from "../../components/BadgeDetails.vue";
import { computed } from 'vue'
import mixin        from "../../Mixin.js";
import verificationTypesMixin from "../../verificationTypesMixin.js";

import deleteBadgeIcon  from '../../../images/popup/delete-badge.svg';
import successBadgeIcon from '../../../images/popup/badge-success.svg';
import publishBadgeIcon from '../../../images/popup/publish-badge.svg';
import updateBadgeIcon  from '../../../images/popup/update-badge.svg';
import draftBadgeIcon   from '../../../images/popup/draft-badge.svg';

const apiBase = '/seller-badge/'

export default {
    name: 'SellerBadgeList',
    mixins: [mixin, verificationTypesMixin],
    components:{
        ListTable,
        AdminNotice,
        Modal,
        Debounce,
        Search,
        BadgeDetails,
        successBadgeIcon,
        deleteBadgeIcon,
        publishBadgeIcon,
        updateBadgeIcon,
        draftBadgeIcon,
    },
    data(){
        return {
            requests: [],
            badge: {
                id: 0,
                ts: false
            },
            loading: false,
            badge_status: {
                'published' : this.__( 'Published', 'dokan' ),
                'draft' : this.__( 'Draft', 'dokan' ),
            },
            columns: {
                'badge_name': {
                    label: this.__( 'Badges Name', 'dokan' ),
                    sortable: true
                },
                'event_type': {
                    label: this.__( 'Badge Event', 'dokan' ),
                    sortable: true
                },
                'vendor_count': {
                    label: this.__( 'No. of Vendors', 'dokan' ),
                    sortable: true
                },
                'badge_status': {
                    label: this.__( 'Status' ),
                    sortable: false,
                },
            },
            actionColumn: 'badge_name',
            counts: {
                all: 0,
                published: 0,
                draft: 0,
            },
            showCb: true,
            totalPages: 1,
            totalItems: 0,
            perPage: 15,
            notFound: this.__( 'No badges found.', 'dokan' ),
            actions: [
                {
                    key: 'edit',
                    label: this.__( 'Edit', 'dokan' )
                },
                {
                    key: 'view',
                    label: this.__( 'Preview', 'dokan' )
                },
                {
                    key: 'show_vendors',
                    label: this.__( 'Show Vendors', 'dokan' )
                },
                {
                    key: 'publish',
                    label: this.__( 'Publish Badge', 'dokan' )
                },
                {
                    key: 'draft',
                    label: this.__( 'Set Badge As Draft', 'dokan' )
                },
                {
                    key: 'delete',
                    label: this.__( 'Delete', 'dokan' )
                },

            ],
            filters: {
                badge_id: 0,
                badge_name: '',
                vendor_id: 0,
                event_type: '',
                return: 'all',
            },
        }
    },
    watch: {
        '$route.query.badge_status'() {
            this.fetchAllBadges();
        },
        '$route.query.orderby'() {
            this.fetchAllBadges();
        },
        '$route.query.order'() {
            this.fetchAllBadges();
        },
        '$route.query.page'() {
            this.fetchAllBadges();
        }
    },
    provide() {
        // use function syntax so that we can access `this`
        return {
            getBadgeValue: computed(() => this.badge ),
            getVerificationTypes: computed( () => this.verificationTypes ),
        }
    },
    methods:{
        // search by badge name
        searchByBadge: Debounce( function( payload ) {
            this.filters.badge_name = payload;
            this.fetchAllBadges();
        }, 300 ),

        fetchAllBadges() {
            this.loading = true;
            let self = this;
            let args = {
                badge_status: this.getCurrentBadgeStatus,
                return: this.filters.return,
                per_page: parseInt( this.perPage ),
                page: parseInt( this.getCurrentPage ),
                orderby: this.getSortBy,
                order: this.getSortOrder,
            };

            if ( this.filters.badge_name ) {
                args.badge_name = this.filters.badge_name;
            }
            if ( this.filters.badge_id ) {
                args.badge_id = this.filters.badge_id;
            }
            if ( this.filters.event_type ) {
                args.event_type = this.filters.event_type;
            }
            if ( this.filters.vendor_id ) {
                args.vendor_id = this.filters.vendor_id;
            }

            dokan.api.get(apiBase, args )
            .done( ( response, status, xhr ) => {
                self.requests = response;
                self.updatedCounts( xhr );
                self.updatePagination( xhr );
            }).always( () => {
                self.loading = false;
            } ).fail( ( jqXHR ) => {
                self.requests = [];
                self.resetCounts();
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },

        updatedCounts( xhr ) {
            this.counts.all       = parseInt( xhr.getResponseHeader('X-Status-All') );
            this.counts.published = parseInt( xhr.getResponseHeader('X-Status-Published') );
            this.counts.draft     = parseInt( xhr.getResponseHeader('X-Status-Draft') );
        },

        resetCounts() {
            this.counts.all  = 0;
            this.counts.published = 0;
            this.counts.draft = 0;
            this.totalPages = 0;
            this.totalItems = 0;
        },

        updatePagination(xhr) {
            this.totalPages = parseInt( xhr.getResponseHeader('X-WP-TotalPages') );
            this.totalItems = parseInt( xhr.getResponseHeader('X-WP-Total') );
        },

        handleBulkAction( action, items ) {
            this.handelActions( action, items, 'bulk_actions' );
        },

        handleRowAction( action, items ) {
            this.handelActions( action, items, 'row_actions' );
        },

        handelActions( action, badge_ids, action_type = 'bulk_actions' ) {
            let self = this;

            if ( ! [ 'publish', 'draft', 'delete' ].includes( action ) ) {
                self.loading = false;
                this.getSwal().fire(
                    '',
                    self.__( 'Invalid row action. Supported actions are Publish, Draft and Delete', 'dokan' ),
                    'error'
                );
                return;
            }

            let title,
                message,
                icon = 'info',
                iconSuccess = successBadgeIcon,
                confirmButtonText,
                successMessage,
                actionApi = 'bulk_actions' === action_type ? apiBase + 'bulk-actions/' : apiBase + 'row-actions/',
                actionApiData = {
                    action: action,
                    ids: badge_ids,
                };

            if ( 'publish' === action ) {
                title             = this.__( 'Publish selected badge?', 'dokan' );
                message           = this.__( 'Are you sure you want to publish selected badges? Note that, badge will be assigned to the eligible vendors as soon as they get published.', 'dokan' );
                confirmButtonText = this.__( 'Yes, Publish', 'dokan' );
                successMessage    = this.__( 'Selected badges published successfully.', 'dokan' );
                icon              = publishBadgeIcon;
            } else if ( 'draft' === action ) {
                title             = this.__( 'Draft selected badge?', 'dokan' );
                message           = this.__( 'Are you sure you want move selected badges to draft? Note that, drafted badge will not be visible from vendor profile page.', 'dokan' );
                confirmButtonText = this.__( 'Yes, Draft', 'dokan' );
                successMessage    = this.__( 'Selected badges moved to draft successfully.', 'dokan' );
                icon              = draftBadgeIcon;
            } else if ( 'delete' === action ) {
                title             = this.__('Delete selected Badge?', 'dokan');
                message           = this.__('Are you sure you want to delete selected badge? Note that, this action is permanent. All badge level data, seller acquired data related to the selected badges will be deleted.', 'dokan');
                confirmButtonText = this.__('Yes, Delete', 'dokan');
                successMessage    = this.__('Selected badges deleted successfully.', 'dokan');
                icon              = deleteBadgeIcon;
            }

            let swal_options = {
                title: title,
                text: message,
                imageUrl: icon,
                width: 600,
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonText: this.__( 'No, Cancel', 'dokan' ),
                confirmButtonText: confirmButtonText,
                confirmButtonColor: '#1A9ED4',
                showLoaderOnConfirm: true,
            };

            if ( 'delete' === action ) {
                swal_options.confirmButtonColor = '#FF6F6F';
            }

            this.getSwal().fire( {
                ...swal_options,
                preConfirm: () => {
                    return dokan.api.put( actionApi, actionApiData )
                    .done( ( response, status, xhr ) => {
                        return response;
                    }).always( () => {
                        self.loading = false;
                    }).catch( (jqXHR) => {
                        let message = dokan_handle_ajax_error( jqXHR );
                        if ( message ) {
                            self.showErrorAlert( message );
                        }
                        return false;
                    });
                },
                allowOutsideClick: () => !self.getSwal().isLoading(),
                backdrop: true,
            } ).then( ( result ) => {
                // show success message
                if (result.isConfirmed) {
                    if ( result.value.error ) {
                        let message = result.value.error.errors.batch_update_error[0];
                        Swal.fire({
                            icon: 'error',
                            html: message
                        });
                        return;
                    }

                    self.getSwal().fire({
                        imageUrl: iconSuccess,
                        text: successMessage
                    });

                    self.fetchAllBadges();
                }
            });
        },

        viewBadgeDetails( badge_id ) {
            this.badge.id = badge_id;
            this.badge.ts = Math.random();
        },

        editBadgeURL( badge_id ) {
            return '?page=dokan#/dokan-seller-badge/edit/' + badge_id
        },

        goToPage(page) {
            this.$router.push({
                name: 'SellerBadgeList',
                query: {
                    orderby: this.getSortBy,
                    order: this.getSortOrder,
                    badge_status: this.getCurrentBadgeStatus,
                    page: page
                }
            });
        },

        doSort( column, order ) {
            this.$router.push({
                name: 'SellerBadgeList',
                query: {
                    page: 1,
                    orderby: column,
                    order: order
                }
            });
        },
    },
    computed: {
        getCurrentBadgeStatus() {
            return this.$route.query.badge_status ? this.$route.query.badge_status : 'all';
        },

        bulkActions() {
            if ( 'published' === this.$route.query.badge_status ) {
                return [
                    {
                        key: 'draft',
                        label: this.__( 'Draft', 'dokan' )
                    },
                    {
                        key: 'delete',
                        label: this.__( 'Delete', 'dokan' )
                    }
                ];
            }  else if ( 'draft' === this.$route.query.badge_status ) {
                return [
                    {
                        key: 'publish',
                        label: this.__( 'Publish', 'dokan' )
                    },
                    {
                        key: 'delete',
                        label: this.__( 'Delete', 'dokan' )
                    }
                ];
            } else {
                return [
                    {
                        key: 'delete',
                        label: this.__( 'Delete', 'dokan' )
                    }
                ];
            }
        },
        getSortBy() {
            return this.$route.query.orderby ?? 'badge_id';
        },
        getSortOrder() {
            return this.$route.query.order ?? 'asc';
        },
        getCurrentPage () {
            let page = this.$route.query.page || 1;
            return parseInt(page);
        },
        getSearchText() {
            return this.filters.search ?? '';
        },
    },
    created() {
        this.fetchAllBadges();
    },
};
</script>

<style lang="less" scoped>
.seller-badge-list {
    font-family: "SF Pro Text", sans-serif;
    .wp-heading-inline {
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 20px;
    }
    .list_description {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 13px;
    }

    #seller_badge_list_table {
        .badge_name {
            width: 30%;
        }

        td.badge_name img {
            float: left;
            margin-right: 10px;
            margin-top: 1px;
            width: 40px;
            height: auto;
        }

        span.dashicons.dashicons-admin-users {
            margin-right: 7px;
            color: #A5B1C1;
        }

        .count {
            color: #525252;
        }

        td.badge_status {
            padding: 15px 0 0 0;

            span.draft {
                color: #777777;
                background: #e5e5e5;
                padding: 6px 15px 6px 15px;
                border-radius: 3px;
            }

            span.published {
                color: #138972;
                background: #ddf0ed;
                padding: 6px 15px;
                border-radius: 3px;
                font-size: 12px;
            }
        }

        td.event_type {
            span {
                display: block;
            }
            span.level_count {
                font-size: 11px;
            }
        }
    }
}
</style>

<style lang="less">
    .seller-badge-cs-font {
        font-family: "SF Pro Text", sans-serif !important;

        .swal2-html-container {
            line-height: 1.4325;
        }
    }
</style>
